export default __webpack_public_path__ + "static/media/25.d6f4f1d5.jpg";